import React from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import Box from "@mui/material/Box";
import "./Compliance.scss";

function ComplianceScore({ overrideClass = null, headerData, stateName }) {
  let outterArcData = [];
  if (headerData?.overallYesPercentage >= 75) {
    outterArcData = [{
      id: 0,
      value: headerData?.overallYesPercentage,
      label: `Yes: ${headerData?.overallYesPercentage?.toFixed(1)}%`,
      color: "#14B8A6",
    },{
      id: 1,
      value: 100-headerData?.overallYesPercentage,
      label: null,
      color: "none"
    }]
  } else if (headerData?.overallYesPercentage >= 50) {
    outterArcData = [{
      id: 0,
      value: headerData?.overallYesPercentage,
      label: `Yes: ${headerData?.overallYesPercentage?.toFixed(1)}%`,
      color: "#ED9E00",
    },{
      id: 1,
      value: 100-headerData?.overallYesPercentage,
      label: null,
      color: "none"
    }]
  } else {
    outterArcData = [{
      id: 0,
      value: headerData?.overallYesPercentage,
      label: `Yes: ${headerData?.overallYesPercentage?.toFixed(1)}%`,
      color: "#E93123",
    },{
      id: 1,
      value: 100-headerData?.overallYesPercentage,
      label: null,
      color: "none"
    }]
  }
  return (
    <div className={overrideClass ? overrideClass + " boxContainer" : "boxContainer"}>
      <div className="score-container">
        <div className="pie-chart-container">
          <Box>
            <PieChart
              series={[
                {
                  data: [
                    {
                      id: 0,
                      value: headerData?.overallYesPercentage,
                      label: `Yes: ${headerData?.overallYesPercentage?.toFixed(
                        1
                      )}%`,
                    },
                    {
                      id: 1,
                      value: headerData?.overallNoPercentage,
                      label: `No: ${headerData?.overallNoPercentage?.toFixed(
                        1
                      )}%`,
                    },
                    {
                      id: 2,
                      value: headerData?.overallUnknownPercentage,
                      label: `Unknown: ${headerData?.overallUnknownPercentage?.toFixed(
                        1
                      )}%`,
                    },
                  ],
                  innerRadius: 0,
                  outerRadius: 50,
                },
                {
                  data: outterArcData,
                  innerRadius: 55,
                  outerRadius: 60,
                },
              ]}
              colors={["#14b8a6", "#e93123", "#A9A9A9	"]}
              width={300}
              height={280}
              slotProps={{
                legend: { hidden: true },
              }}
              sx={{
                "& .MuiPieArc-root": {
                  stroke: "white",
                  strokeWidth: 1,
                },
              }}
              margin={{ left: 100 }}
            />
          </Box>
        </div>
        <div className="text-container">
          <p className="score-state">{headerData?.stateName}</p>
          <p className="score-title">Current Score</p>
          <p className="score-value">{`${Math.floor(
            headerData?.overallYesPercentage
          )}%`}</p>
          <p className="last-updated">{`last Updated: ${headerData?.lastUpdate}`}</p>
        </div>
      </div>
    </div>
  );
};

export default ComplianceScore;